/**
 * This file was generated by Style Dictionary and contains the semantic tokens for the lodestar-light theme.
 * To make changes, edit the corresponding JSON file in the token-groups/themes directory.
 * This file is automatically generated and should not be edited directly.
 **/
export const lodestarLightColors = {
  colorBackgroundAiIconWrapperDefault: "#f5f5fe",
  colorBackgroundDestructiveDefault: "#d03340",
  colorBackgroundDestructiveStrong: "#a62833",
  colorBackgroundDestructiveStronger: "#7c1e26",
  colorBackgroundDestructiveStrongest: "#531419",
  colorBackgroundDestructiveWeak: "#db656f",
  colorBackgroundDestructiveWeaker: "#e4969c",
  colorBackgroundDestructiveWeakest: "#efc8cb",
  colorBackgroundErrorDefault: "#d14424",
  colorBackgroundErrorWeak: "#ffe0d7",
  colorBackgroundErrorWeaker: "#fff3ef",
  colorBackgroundInfoDefault: "#007cc5",
  colorBackgroundInfoWeak: "#a7c1e4",
  colorBackgroundInfoWeaker: "#d8e4fa",
  colorBackgroundNeutralDefault: "#e0e0e0",
  colorBackgroundNeutralStrong: "#c0c0c0",
  colorBackgroundNeutralStronger: "#979797",
  colorBackgroundNeutralStrongest: "#444444",
  colorBackgroundNeutralWeak: "#ebebeb",
  colorBackgroundNeutralWeaker: "#f2f2f2",
  colorBackgroundNeutralWeakest: "#ffffff",
  colorBackgroundNeutralInverseDefault: "#979797",
  colorBackgroundNeutralInverseStrong: "#727272",
  colorBackgroundNeutralInverseStronger: "#444444",
  colorBackgroundNeutralInverseStrongest: "#444444",
  colorBackgroundNeutralInverseWeak: "#c0c0c0",
  colorBackgroundNeutralInverseWeaker: "#e0e0e0",
  colorBackgroundNeutralInverseWeakest: "#ebebeb",
  colorBackgroundNotificationsDefault: "#d14424",
  colorBackgroundNotificationsWeak: "#007cc5",
  colorBackgroundPrimaryDefault: "#5996d6",
  colorBackgroundPrimaryStrong: "#007cc5",
  colorBackgroundPrimaryStronger: "#004173",
  colorBackgroundPrimaryStrongest: "#002847",
  colorBackgroundPrimaryWeak: "#a7c1e4",
  colorBackgroundPrimaryWeaker: "#d8e4fa",
  colorBackgroundPrimaryWeakest: "#f0f5fd",
  colorBackgroundSlateDefault: "#e0e0e0",
  colorBackgroundSlateStrong: "#c0c0c0",
  colorBackgroundSlateStronger: "#979797",
  colorBackgroundSlateStrongest: "#444444",
  colorBackgroundSlateWeak: "#ebebeb",
  colorBackgroundSlateWeaker: "#f2f2f2",
  colorBackgroundSlateWeakest: "#ffffff",
  colorBackgroundSlateInverseDefault: "#979797",
  colorBackgroundSlateInverseStrong: "#727272",
  colorBackgroundSlateInverseStronger: "#444444",
  colorBackgroundSlateInverseStrongest: "#444444",
  colorBackgroundSlateInverseWeak: "#c0c0c0",
  colorBackgroundSlateInverseWeaker: "#e0e0e0",
  colorBackgroundSlateInverseWeakest: "#ebebeb",
  colorBackgroundSpectrumAquaDefault: "#4eaa9b",
  colorBackgroundSpectrumAquaStrong: "#008476",
  colorBackgroundSpectrumAquaStronger: "#004e43",
  colorBackgroundSpectrumAquaStrongest: "#002923",
  colorBackgroundSpectrumAquaWeak: "#a1c9c2",
  colorBackgroundSpectrumAquaWeaker: "#dceae7",
  colorBackgroundSpectrumAquaWeakest: "#f1f7f6",
  colorBackgroundSpectrumAzureDefault: "#5996d6",
  colorBackgroundSpectrumAzureStrong: "#007cc5",
  colorBackgroundSpectrumAzureStronger: "#004173",
  colorBackgroundSpectrumAzureStrongest: "#002847",
  colorBackgroundSpectrumAzureWeak: "#a7c1e4",
  colorBackgroundSpectrumAzureWeaker: "#d8e4fa",
  colorBackgroundSpectrumAzureWeakest: "#f0f5fd",
  colorBackgroundSpectrumBlueDefault: "#5996d6",
  colorBackgroundSpectrumBlueStrong: "#007cc5",
  colorBackgroundSpectrumBlueStronger: "#004173",
  colorBackgroundSpectrumBlueStrongest: "#002847",
  colorBackgroundSpectrumBlueWeak: "#a7c1e4",
  colorBackgroundSpectrumBlueWeaker: "#d8e4fa",
  colorBackgroundSpectrumBlueWeakest: "#f0f5fd",
  colorBackgroundSpectrumGoldDefault: "#e18502",
  colorBackgroundSpectrumGoldStrong: "#ab6600",
  colorBackgroundSpectrumGoldStronger: "#653300",
  colorBackgroundSpectrumGoldStrongest: "#492400",
  colorBackgroundSpectrumGoldWeak: "#ffb761",
  colorBackgroundSpectrumGoldWeaker: "#fee3c0",
  colorBackgroundSpectrumGoldWeakest: "#fff4e6",
  colorBackgroundSpectrumGreenDefault: "#70a13c",
  colorBackgroundSpectrumGreenStrong: "#488306",
  colorBackgroundSpectrumGreenStronger: "#275600",
  colorBackgroundSpectrumGreenStrongest: "#193700",
  colorBackgroundSpectrumGreenWeak: "#b2c997",
  colorBackgroundSpectrumGreenWeaker: "#e1ebd6",
  colorBackgroundSpectrumGreenWeakest: "#f3f7ef",
  colorBackgroundSpectrumIndigoDefault: "#848be9",
  colorBackgroundSpectrumIndigoStrong: "#566ae3",
  colorBackgroundSpectrumIndigoStronger: "#0c3491",
  colorBackgroundSpectrumIndigoStrongest: "#0c245b",
  colorBackgroundSpectrumIndigoWeak: "#bab8f1",
  colorBackgroundSpectrumIndigoWeaker: "#e6e5fa",
  colorBackgroundSpectrumIndigoWeakest: "#f5f5fe",
  colorBackgroundSpectrumMintDefault: "#01af6a",
  colorBackgroundSpectrumMintStrong: "#008c54",
  colorBackgroundSpectrumMintStronger: "#00693f",
  colorBackgroundSpectrumMintStrongest: "#00462a",
  colorBackgroundSpectrumMintWeak: "#40c28f",
  colorBackgroundSpectrumMintWeaker: "#7dd4b1",
  colorBackgroundSpectrumMintWeakest: "#bbe7d6",
  colorBackgroundSpectrumNeutralDefault: "#c0c0c0",
  colorBackgroundSpectrumNeutralStrong: "#979797",
  colorBackgroundSpectrumNeutralStronger: "#727272",
  colorBackgroundSpectrumNeutralStrongest: "#444444",
  colorBackgroundSpectrumNeutralWeak: "#e0e0e0",
  colorBackgroundSpectrumNeutralWeaker: "#ebebeb",
  colorBackgroundSpectrumNeutralWeakest: "#f2f2f2",
  colorBackgroundSpectrumOrangeDefault: "#e18502",
  colorBackgroundSpectrumOrangeStrong: "#ab6600",
  colorBackgroundSpectrumOrangeStronger: "#653300",
  colorBackgroundSpectrumOrangeStrongest: "#492400",
  colorBackgroundSpectrumOrangeWeak: "#ffb761",
  colorBackgroundSpectrumOrangeWeaker: "#fee3c0",
  colorBackgroundSpectrumOrangeWeakest: "#fff4e6",
  colorBackgroundSpectrumOrchidDefault: "#c76ca1",
  colorBackgroundSpectrumOrchidStrong: "#b94d90",
  colorBackgroundSpectrumOrchidStronger: "#8b2066",
  colorBackgroundSpectrumOrchidStrongest: "#610e44",
  colorBackgroundSpectrumOrchidWeak: "#e5b8d1",
  colorBackgroundSpectrumOrchidWeaker: "#f5e1ec",
  colorBackgroundSpectrumOrchidWeakest: "#fbf3f8",
  colorBackgroundSpectrumPinkDefault: "#c76ca1",
  colorBackgroundSpectrumPinkStrong: "#b94d90",
  colorBackgroundSpectrumPinkStronger: "#8b2066",
  colorBackgroundSpectrumPinkStrongest: "#610e44",
  colorBackgroundSpectrumPinkWeak: "#e5b8d1",
  colorBackgroundSpectrumPinkWeaker: "#f5e1ec",
  colorBackgroundSpectrumPinkWeakest: "#fbf3f8",
  colorBackgroundSpectrumRedDefault: "#ee6f4c",
  colorBackgroundSpectrumRedStrong: "#d14424",
  colorBackgroundSpectrumRedStronger: "#9d0c00",
  colorBackgroundSpectrumRedStrongest: "#6d0800",
  colorBackgroundSpectrumRedWeak: "#f6b09d",
  colorBackgroundSpectrumRedWeaker: "#ffe0d7",
  colorBackgroundSpectrumRedWeakest: "#fff3ef",
  colorBackgroundSpectrumRoseDefault: "#c76ca1",
  colorBackgroundSpectrumRoseStrong: "#b94d90",
  colorBackgroundSpectrumRoseStronger: "#8b2066",
  colorBackgroundSpectrumRoseStrongest: "#610e44",
  colorBackgroundSpectrumRoseWeak: "#e5b8d1",
  colorBackgroundSpectrumRoseWeaker: "#f5e1ec",
  colorBackgroundSpectrumRoseWeakest: "#fbf3f8",
  colorBackgroundSpectrumSlateDefault: "#c0c0c0",
  colorBackgroundSpectrumSlateStrong: "#979797",
  colorBackgroundSpectrumSlateStronger: "#727272",
  colorBackgroundSpectrumSlateStrongest: "#444444",
  colorBackgroundSpectrumSlateWeak: "#e0e0e0",
  colorBackgroundSpectrumSlateWeaker: "#ebebeb",
  colorBackgroundSpectrumSlateWeakest: "#f2f2f2",
  colorBackgroundSpectrumTealDefault: "#4eaa9b",
  colorBackgroundSpectrumTealStrong: "#008476",
  colorBackgroundSpectrumTealStronger: "#004e43",
  colorBackgroundSpectrumTealStrongest: "#002923",
  colorBackgroundSpectrumTealWeak: "#a1c9c2",
  colorBackgroundSpectrumTealWeaker: "#dceae7",
  colorBackgroundSpectrumTealWeakest: "#f1f7f6",
  colorBackgroundSpectrumVioletDefault: "#848be9",
  colorBackgroundSpectrumVioletStrong: "#566ae3",
  colorBackgroundSpectrumVioletStronger: "#0c3491",
  colorBackgroundSpectrumVioletStrongest: "#0c245b",
  colorBackgroundSpectrumVioletWeak: "#bab8f1",
  colorBackgroundSpectrumVioletWeaker: "#e6e5fa",
  colorBackgroundSpectrumVioletWeakest: "#f5f5fe",
  colorBackgroundSpectrumYellowDefault: "#e6a907",
  colorBackgroundSpectrumYellowStrong: "#996f00",
  colorBackgroundSpectrumYellowStronger: "#5a4000",
  colorBackgroundSpectrumYellowStrongest: "#3d2c00",
  colorBackgroundSpectrumYellowWeak: "#f5cf6a",
  colorBackgroundSpectrumYellowWeaker: "#ffefc5",
  colorBackgroundSpectrumYellowWeakest: "#fff8e7",
  colorBackgroundSuccessDefault: "#008c54",
  colorBackgroundSuccessWeak: "#7dd4b1",
  colorBackgroundSuccessWeaker: "#bbe7d6",
  colorBackgroundSurfacesBody: "#ffffff",
  colorBackgroundSurfacesCanvas: "#ffffff",
  colorBackgroundSurfacesOverlay: "#000000",
  colorBackgroundSurfacesStage: "#111111",
  colorBackgroundSurfacesWork: "#ffffff",
  colorBackgroundWarningDefault: "#cc9c31",
  colorBackgroundWarningWeak: "#fcde9b",
  colorBackgroundWarningWeaker: "#fbeccb",
  colorBorderErrorDefault: "#d03340",
  colorBorderNeutralDefault: "#c0c0c0",
  colorBorderNeutralStrong: "#979797",
  colorBorderNeutralStronger: "#727272",
  colorBorderNeutralStrongest: "#444444",
  colorBorderNeutralWeak: "#e0e0e0",
  colorBorderNeutralWeaker: "#ebebeb",
  colorBorderNeutralWeakest: "#f2f2f2",
  colorBorderPrimaryDefault: "#5996d6",
  colorBorderPrimaryWeak: "#a7c1e4",
  colorBorderPrimaryWeaker: "#d8e4fa",
  colorBorderPrimaryWeakest: "#f0f5fd",
  colorBorderSlateDefault: "#c0c0c0",
  colorBorderSlateStrong: "#979797",
  colorBorderSlateStronger: "#727272",
  colorBorderSlateStrongest: "#444444",
  colorBorderSlateWeak: "#e0e0e0",
  colorBorderSlateWeaker: "#ebebeb",
  colorBorderSlateWeakest: "#f2f2f2",
  colorBorderSpectrumAquaDefault: "#004e43",
  colorBorderSpectrumAzureDefault: "#004173",
  colorBorderSpectrumBlueDefault: "#004173",
  colorBorderSpectrumSlateDefault: "#727272",
  colorBorderSpectrumGoldDefault: "#997525",
  colorBorderSpectrumGreenDefault: "#275600",
  colorBorderSpectrumIndigoDefault: "#0c3491",
  colorBorderSpectrumMintDefault: "#00693f",
  colorBorderSpectrumNeutralDefault: "#727272",
  colorBorderSpectrumOrangeDefault: "#997525",
  colorBorderSpectrumOrchidDefault: "#8b2066",
  colorBorderSpectrumPinkDefault: "#8b2066",
  colorBorderSpectrumRedDefault: "#7c1e26",
  colorBorderSpectrumRoseDefault: "#8b2066",
  colorBorderSpectrumTealDefault: "#004e43",
  colorBorderSpectrumVioletDefault: "#0c3491",
  colorBorderSpectrumYellowDefault: "#5a4000",
  colorBorderSuccessDefault: "#01af6a",
  colorBorderSurfacesBody: "#ffffff",
  colorBorderSurfacesCanvas: "#ffffff",
  colorBorderSurfacesFocus: "#5996d6",
  colorBorderSurfacesStage: "#111111",
  colorBorderSurfacesWork: "#ffffff",
  colorBorderWarningDefault: "#ffc33e",
  colorIconsNeutralDefault: "#c0c0c0",
  colorIconsNeutralStrong: "#979797",
  colorIconsNeutralStronger: "#727272",
  colorIconsNeutralStrongest: "#444444",
  colorIconsNeutralWeak: "#f2f2f2",
  colorIconsNeutralWeaker: "#ebebeb",
  colorIconsNeutralWeakest: "#f2f2f2",
  colorIconsNeutralInverseDefault: "#ffffff",
  colorIconsNeutralInverseWeak: "#f2f2f2",
  colorIconsPrimaryDefault: "#5996d6",
  colorIconsPrimaryStrong: "#007cc5",
  colorIconsPrimaryStronger: "#004173",
  colorIconsPrimaryStrongest: "#002847",
  colorIconsPrimaryWeak: "#a7c1e4",
  colorIconsPrimaryWeaker: "#d8e4fa",
  colorIconsPrimaryWeakest: "#f0f5fd",
  colorIconsPrimaryInverseStronger: "#a7c1e4",
  colorIconsSlateDefault: "#c0c0c0",
  colorIconsSlateStrong: "#979797",
  colorIconsSlateStronger: "#727272",
  colorIconsSlateStrongest: "#444444",
  colorIconsSlateWeak: "#f2f2f2",
  colorIconsSlateWeaker: "#ebebeb",
  colorIconsSlateWeakest: "#f2f2f2",
  colorIconsSlateInverseDefault: "#ffffff",
  colorIconsSlateInverseWeak: "#f2f2f2",
  colorIconsSpectrumAquaDefault: "#004e43",
  colorIconsSpectrumAzureDefault: "#002847",
  colorIconsSpectrumBlueDefault: "#002847",
  colorIconsSpectrumGoldDefault: "#653300",
  colorIconsSpectrumGreenDefault: "#193700",
  colorIconsSpectrumIndigoDefault: "#0c245b",
  colorIconsSpectrumIndigoWeak: "#566ae3",
  colorIconsSpectrumIndigoWeaker: "#bab8f1",
  colorIconsSpectrumIndigoWeakest: "#e6e5fa",
  colorIconsSpectrumMintDefault: "#00462a",
  colorIconsSpectrumNeutralDefault: "#444444",
  colorIconsSpectrumOrangeDefault: "#653300",
  colorIconsSpectrumOrchidDefault: "#610e44",
  colorIconsSpectrumPinkDefault: "#610e44",
  colorIconsSpectrumRedDefault: "#6d0800",
  colorIconsSpectrumRoseDefault: "#610e44",
  colorIconsSpectrumSlateDefault: "#444444",
  colorIconsSpectrumTealDefault: "#004e43",
  colorIconsSpectrumVioletDefault: "#0c245b",
  colorIconsSpectrumYellowDefault: "#5a4000",
  colorIconsSuccessDefault: "#00693f",
  colorIconsSuccessWeak: "#008c54",
  colorIconsWarningDefault: "#997525",
  colorIconsWarningWeak: "#ffc33e",
  colorIconsInfoDefault: "#004173",
  colorIconsInfoWeak: "#007cc5",
  colorIconsErrorDefault: "#7c1e26",
  colorIconsErrorWeak: "#d03340",
  colorIconsDestructiveDefault: "#ee6f4c",
  colorIconsDestructiveStrong: "#d14424",
  colorIconsDestructiveStronger: "#9d0c00",
  colorIconsDestructiveStrongest: "#6d0800",
  colorIconsDestructiveWeak: "#f6b09d",
  colorIconsDestructiveWeaker: "#ffe0d7",
  colorIconsDestructiveWeakest: "#fff3ef",
  colorIconsDestructiveInverseStronger: "#fff3ef",
  colorTextErrorDefault: "#6d0800",
  colorTextErrorWeak: "#9d0c00",
  colorTextInfoDefault: "#3f4952",
  colorTextInfoWeak: "#5e6d7b",
  colorTextNeutralDefault: "#444444",
  colorTextNeutralStrong: "#111111",
  colorTextNeutralWeak: "#727272",
  colorTextNeutralWeaker: "#979797",
  colorTextNeutralWeakest: "#c0c0c0",
  colorTextNeutralInverseDefault: "#f2f2f2",
  colorTextNeutralInverseStrong: "#ffffff",
  colorTextNeutralInverseWeak: "#ebebeb",
  colorTextPrimaryDefault: "#5996d6",
  colorTextPrimaryStrong: "#007cc5",
  colorTextPrimaryStronger: "#004173",
  colorTextPrimaryStrongest: "#002847",
  colorTextPrimaryWeak: "#a7c1e4",
  colorTextPrimaryWeaker: "#d8e4fa",
  colorTextPrimaryWeakest: "#f0f5fd",
  colorTextSlateDefault: "#444444",
  colorTextSlateStrong: "#111111",
  colorTextSlateWeak: "#727272",
  colorTextSlateWeaker: "#979797",
  colorTextSlateWeakest: "#c0c0c0",
  colorTextSlateInverseDefault: "#f2f2f2",
  colorTextSlateInverseStrong: "#ffffff",
  colorTextSlateInverseWeak: "#ebebeb",
  colorTextSpectrumAquaDefault: "#004e43",
  colorTextSpectrumAquaStrong: "#002923",
  colorTextSpectrumAzureDefault: "#004173",
  colorTextSpectrumAzureStrong: "#002847",
  colorTextSpectrumBlueDefault: "#004173",
  colorTextSpectrumBlueStrong: "#002847",
  colorTextSpectrumGoldDefault: "#653300",
  colorTextSpectrumGoldStrong: "#492400",
  colorTextSpectrumGreenDefault: "#275600",
  colorTextSpectrumGreenStrong: "#193700",
  colorTextSpectrumIndigoDefault: "#0c3491",
  colorTextSpectrumIndigoStrong: "#0c245b",
  colorTextSpectrumIndigoWeak: "#566ae3",
  colorTextSpectrumMintDefault: "#00693f",
  colorTextSpectrumMintStrong: "#00462a",
  colorTextSpectrumNeutralDefault: "#727272",
  colorTextSpectrumNeutralStrong: "#444444",
  colorTextSpectrumOrangeDefault: "#653300",
  colorTextSpectrumOrangeStrong: "#492400",
  colorTextSpectrumOrchidDefault: "#8b2066",
  colorTextSpectrumOrchidStrong: "#610e44",
  colorTextSpectrumPinkDefault: "#8b2066",
  colorTextSpectrumPinkStrong: "#610e44",
  colorTextSpectrumRedDefault: "#9d0c00",
  colorTextSpectrumRedStrong: "#6d0800",
  colorTextSpectrumRoseDefault: "#8b2066",
  colorTextSpectrumRoseStrong: "#610e44",
  colorTextSpectrumSlateDefault: "#727272",
  colorTextSpectrumSlateStrong: "#444444",
  colorTextSpectrumTealDefault: "#004e43",
  colorTextSpectrumTealStrong: "#002923",
  colorTextSpectrumVioletDefault: "#0c3491",
  colorTextSpectrumVioletStrong: "#0c245b",
  colorTextSpectrumYellowDefault: "#5a4000",
  colorTextSpectrumYellowStrong: "#3d2c00",
  colorTextSuccessDefault: "#00462a",
  colorTextSuccessWeak: "#00693f",
  colorTextWarningDefault: "#664e18",
  colorTextWarningWeak: "#997525",
  bannerBackgroundColorInfo: "#CAE8FC",
  bannerBackgroundColorWarning: "#FFEECC",
  bannerBackgroundColorError: "#FAD1D4",
  bannerBackgroundColorSuccess: "#E0F2E4",
  bannerTextColorInfo: "#001F33",
  bannerTextColorWarning: "#4C1D00",
  bannerTextColorError: "#280104",
  bannerTextColorSuccess: "#001A06",
  bannerIconColorInfo: "#027ED1",
  bannerIconColorWarning: "#CC7E00",
  bannerIconColorError: "#C21823",
  bannerIconColorSuccess: "#067321",
  symbolBackgroundColorYellowDefault: "#ffc33e",
  symbolBackgroundColorYellowHover: "#fcde9b",
  tooltipBackgroundColor: "#444444",
  elevationLow: "0px 2px 12px 0px rgba(0, 0, 0, 0.16)",
  elevationDefault: "0px 4px 16px 0px rgba(0, 0, 0, 0.12)",
  elevationHigh: "0px 24px 64px rgba(0, 0, 0, 0.12)",
  gradientNavigation: "#003059",
  FocusIndicatorBorderPrimary: "#005d95",
  semanticErrorBackground: "#fbc6c9",
  semanticErrorBackgroundActive: "#e4969c",
  semanticErrorBackgroundHover: "#e4969c",
  semanticErrorIcon: "#ab0d17",
  semanticErrorText: "#330003",
  semanticErrorTextInline: "#ab0d17",
  semanticInfoBackground: "#98dcf1",
  semanticInfoBackgroundActive: "#cbd8e3",
  semanticInfoBackgroundHover: "#cbd8e3",
  semanticInfoIcon: "#0b5c75",
  semanticInfoText: "#001f33",
  semanticInfoTextInline: "#0b5c75",
  semanticSuccessBackground: "#b9f4c3",
  semanticSuccessBackgroundActive: "#7dd4b1",
  semanticSuccessBackgroundHover: "#7dd4b1",
  semanticSuccessIcon: "#177827",
  semanticSuccessText: "#081a00",
  semanticSuccessTextInline: "#0f621c",
  semanticWarningBackground: "#f9cd67",
  semanticWarningBackgroundActive: "#fcde9b",
  semanticWarningBackgroundHover: "#fcde9b",
  semanticWarningIcon: "#543b03",
  semanticWarningText: "#1a1200",
  semanticWarningTextInline: "#543b03",
  surfaceCanvasBackground: "#ffffff",
  surfaceWorkBackground: "#ffffff",
  surfaceWorkText: "#111111"
};
//# sourceMappingURL=lodestar-light.js.map